import React from 'react';
import Button from '@/components/Button/Button';

const NextButton = ({ additionalClasses, action, styles, icon, text, disabled }, ...props) => {
  return (
    <Button
      onButtonClick={action}
      additionalClasses={additionalClasses}
      styles={styles}
      icon={icon}
      text={text}
      disabled={disabled}
      dataCy={'button-restart'}
      type="button"
    />
  );
};

export default NextButton;
